import React from "react";
import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import NewsanIcons from "../../components/common/Icons";
import classes from "./AttributesValues.module.css";

type CrudContainerProps = {
  onClose: () => void;
  onCancel: () => void;
  onSave: () => void;
  onShowForm: () => void;
  isEdit: boolean;
  showForm: boolean;
  children: React.ReactNode;
};

export const CrudContainer = ({
  children,
  onClose,
  onCancel,
  onSave,
  isEdit,
  onShowForm,
  showForm,
}: CrudContainerProps) => {
  return (
    <>
      {!showForm ? (
        <span className={classes["btn-show-form"]} onClick={onShowForm}>
          {NewsanIcons.ADD_OUTLINED}
        </span>
      ) : (
        <div className={classes["abm-container"]}>
          <div
            className={
              isEdit
                ? classes["edit-form-container"]
                : classes["add-form-container"]
            }
          >
            <span className={classes["title-form"]}>
              {isEdit ? <EditIcon /> : NewsanIcons.ADD_OUTLINED}
              <span className={classes["title-form-text"]}>
                {isEdit ? "Editar" : "Agregar"}
              </span>
            </span>
            <CloseIcon
              className={classes["form-close-button"]}
              onClick={onClose}
            ></CloseIcon>

            {children}

            <div className={classes["buttons-container"]}>
              <Button
                variant="contained"
                className={classes["btn-newsan-cancel"]}
                onClick={onCancel}
              >
                Cancelar
              </Button>
              <Button
                variant="contained"
                onClick={onSave}
                className={
                  isEdit
                    ? classes["button-newsan-red"]
                    : classes["button-newsan-grey"]
                }
              >
                {isEdit ? "Guardar" : "Cargar"}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
